export default __webpack_public_path__ + "static/media/icon-copy.a3cafe18.svg";